/**
 * Skills tab configuration for the Service Provider Location Skills flow:
 * REST endpoints and UI flags/messages.
 *
 * Keys under `config.api` / `config.ui.messages` must match what Skills
 * components read (e.g. IndustriesServicedSelector → `industriesServicedSelector`).
 */

function locationBase(apiBaseUrl, serviceProviderId, locationId) {
  return `${apiBaseUrl}/sxcl/v1/service-providers/${serviceProviderId}/locations/${locationId}`;
}

function getConfig({ apiBaseUrl, serviceProviderId, locationId }) {
  const loc = locationBase(apiBaseUrl, serviceProviderId, locationId);
  const emailUrl = `${loc}/notifications/emails`;
  const phonesUrl = `${loc}/notifications/phones`;

  return {
    api: {
      industriesServicedSelector: {
        listBoxLeft: `${loc}/industries`,
        listBoxRight: `${loc}/excluded-industries`,
        listBoxAdd: `${loc}/excluded-industries/bulk-create`,
        listBoxRemove: `${loc}/excluded-industries/bulk-remove`,
      },
      industriesServiced: {
        fetch: `${loc}/industries`,
      },
      productLinesSelector: {
        listBoxLeft: `${loc}/product-lines`,
        listBoxRight: `${loc}/excluded-product-lines`,
        listBoxAdd: `${loc}/excluded-product-lines/bulk-create`,
        listBoxRemove: `${loc}/excluded-product-lines/bulk-remove`,
      },
      brandsSelector: {
        listBoxLeft: `${loc}/brands`,
        listBoxRight: `${loc}/excluded-brands`,
        listBoxAdd: `${loc}/excluded-brands/bulk-create`,
        listBoxRemove: `${loc}/excluded-brands/bulk-remove`,
      },
      setup: {
        emailUrl,
        phonesUrl,
        deleteSelectedPhones: `${phonesUrl}/operation/bulk-delete`,
        exportPhones: `${phonesUrl}/operation/export`,
      },
      claimSettingsApiUrl: `${apiBaseUrl}/sxcl/v1/service-providers/${serviceProviderId}/locations/${locationId}/claim-settings`,
      rateCardApiUrl: `${apiBaseUrl}/sxcl/v1/service-providers/${serviceProviderId}/locations/${locationId}`,
      performanceApiUrl: `${apiBaseUrl}/sxcl/v1/service-providers/${serviceProviderId}/locations/${locationId}/performance`,
    },
    ui: {
      messages: {
        industriesServicedSelector: {
          leftTitle: {
            id: 'INDUSTRIES_AVAILABLE',
            defaultMessage: 'Industries Available',
          },
          rightTitle: {
            id: 'INDUSTRIES_EXCLUDED',
            defaultMessage: 'Industries Excluded',
          },
          saveSuccess: {
            id: 'SERVICE_PROVIDER_LOCATION_INDUSTRIES_ADDED_TO_EXCLUDED_LIST_SUCCESSFULLY',
            defaultMessage:
              'Service Provider Location industries added to excluded list successfully',
          },
          removeSuccess: {
            id: 'SERVICE_PROVIDER_LOCATION_INDUSTRIES_REMOVED_FROM_EXCLUDED_LIST_SUCCESSFULLY',
            defaultMessage:
              'Service Provider Location industries removed from excluded list successfully',
          },
        },
        productLinesSelector: {
          saveSuccess: {
            id: 'SERVICE_PROVIDER_LOCATION_PRODUCT_LINES_EXCLUDED_SUCCESSFULLY',
            defaultMessage:
              'Service Provider Location Product lines excluded successfully',
          },
          removeSuccess: {
            id: 'SERVICE_PROVIDER_LOCATION_PRODUCT_LINES_INCLUDED_SUCCESSFULLY',
            defaultMessage:
              'Service Provider Location Product lines included successfully',
          },
        },
        brandsSelector: {
          saveSuccess: {
            id: 'SERVICE_PROVIDER_LOCATION_BRANDS_EXCLUDED_SUCCESSFULLY',
            defaultMessage:
              'Service Provider Location Brands excluded successfully',
          },
          removeSuccess: {
            id: 'SERVICE_PROVIDER_LOCATION_BRANDS_INCLUDED_SUCCESSFULLY',
            defaultMessage:
              'Service Provider Location Brands included successfully',
          },
        },
        setup: {
          emailSaveSuccess: {
            id: 'SERVICE_PROVIDER_LOCATION_DISPATCH_NOTIFICATIONS_SAVED_SUCCESSFULLY',
            defaultMessage:
              'Service Provider Location dispatch notifications saved successfully',
          },
          emailSaveWarning: {
            id: 'SERVICEPROVIDER_LOCATION_DISPATCH_NOTIFICATIONS_SAVE_WARNING',
            defaultMessage:
              'Service Provider Location dispatch notifications saved with warnings',
          },
          phonesSaveSuccess: {
            id: 'SERVICE_PROVIDER_LOCATION_CUSTOMER_COMMUNICATION_SAVED_SUCCESSFULLY',
            defaultMessage:
              'Service Provider Location customer communication saved successfully',
          },
          phonesSaveWarning: {
            id: 'SERVICEPROVIDER_LOCATION_CUSTOMER_COMMUNICATION_SAVE_WARNING',
            defaultMessage:
              'Service Provider Location customer communication saved with warnings',
          },
        },
      },
    },
  };
}

export default getConfig;
